import { Injectable } from '@angular/core';

import { ApiService } from '@app/services';
import { CustomerFeedBackValue, CustomerFeedBackCommentValue } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class CustomerFeedbackService {

    static CustomerFeedBackValues: Array<CustomerFeedBackValue> = [];
    static CustomerFeedBackCommentsValues: Array<CustomerFeedBackCommentValue> = [];
    
    constructor(
        private apiService: ApiService
    ) {}
    
    async init(){   
        CustomerFeedbackService.CustomerFeedBackValues = await this.loadCustomerFeedBackValueList(); 
        CustomerFeedbackService.CustomerFeedBackCommentsValues = await this.loadCustomerFeedBackCommentValueList(); 
    }
    
    reset(){        
        CustomerFeedbackService.CustomerFeedBackValues = [];
        CustomerFeedbackService.CustomerFeedBackCommentsValues = [];
    }
    
    async loadCustomerFeedBackValueList(): Promise<CustomerFeedBackValue[]> {
        let customerFeedBackValues: Array<CustomerFeedBackValue> = [];
        let response = await this.apiService.get('order/customer-feedback/list');
        if(response?.data){
            customerFeedBackValues = response.data;
        }
        return customerFeedBackValues;
    }

    async loadCustomerFeedBackCommentValueList(): Promise<CustomerFeedBackCommentValue[]> {
        let customerFeedBackCommentsValues: Array<CustomerFeedBackCommentValue> = [];
        let response = await this.apiService.get('order/customer-feedback-comment/list');
        if(response?.data){
            customerFeedBackCommentsValues = response.data;
        }
        return customerFeedBackCommentsValues;
    }
}

